// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36c1c16b","952":"78a9b9c1"}[chunkId] + ".chunk.js";
};